import {PdsWidget} from './pds-widget';

export class PdsReportingTermSelector extends PdsWidget {
  is = 'pds-reporting-term-selector';

  reportingTerms: Array<string>;

  possibleReportingTerms: Array<{value: string, text: string}>;

  selectedReportingTerm: string;

  properties = {
    reportingTerms: {
      value: null,
      type: Array,
      observer: 'setPossibleReportingTerms'
    }
  };

  ready(): void {
    super.ready();
    if (this.possibleReportingTerms == null) {
      this.possibleReportingTerms = [];
    }
  }

  reportingTermChange(event: Event): void {
    event.preventDefault();
    this.fire('reporting-term-change', this.selectedReportingTerm);
  }

  setPossibleReportingTerms(): void {

    if (this.reportingTerms == null) {
      return;
    }

    // only update the possibleReportingTerms if the reporting terms are different
    let different = this.possibleReportingTerms == null || this.possibleReportingTerms.length !== this.reportingTerms.length;
    let newReportingTerms: Array<{text: string, value: string}> = [];
    for (let x = 0; x < this.reportingTerms.length; x ++) {
      if (!different && this.possibleReportingTerms[x].value !== this.reportingTerms[x]) {
        different = true;
      }
      newReportingTerms.push({
        text: this.reportingTerms[x],
        value: this.reportingTerms[x]
      });
    }

    if (different) {
      this.possibleReportingTerms = newReportingTerms;
    }
  }
}
